export default "/images/map_tangle.png?2ffd393495dbed10adb4ea2dcac03444";